import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'
import { store } from './../store'


const routerOptions = [
  { path: '/', component: 'Home'},
  { path: '/signout', component: 'NotFound'},
  { path: '*', component: 'Home' }
]

const routes = routerOptions.map(route => {
  return {
    ...route,
    component: () => import(`@/components/${route.component}.vue`)
  }
})

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})



router.beforeEach((to, from, next) => {
  //5ypNDIWES9RRxFNNRdLh
  
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const isAuthenticated = firebase.auth().currentUser
  if (requiresAuth && !isAuthenticated) {
    next('/')
  } else if (to.path !== "/"){
    var path = to.path.split('/')[1]
    if(/^\b[a-zA-Z0-9]{20}\b/.test(path)){
      //console.log("b"+path)
      store.dispatch('setUrlId', {urlId:path})
      store.dispatch('setLoadingOverlay', {show:true, label:"Ohjataan tilaukseen"})
      //store.state.settings.urlId = path
      next('/')
    }
    else{
      next('/')
    }
    
  } else {
    next()
  }
})


export default router


// WEBPACK FOOTER //
// ./src/router/index.js